<template>
  <button @click="generateCode()" class="btn btn-sm btn-warning" v-tooltip="$t('tooltip.regenerateGameCode')">
    <i class="fa fa-undo"></i>
  </button>
</template>

<script>
import Swal from 'sweetalert2'
import VueI18n from '@/i18n'
import DashboardService from '@/services/dashboard.service'

export default {
  props: {
    gameUuid: {
      type: String,
      default: ''
    }
  },
  methods: {
    generateCode () {
      Swal.fire({
        title: VueI18n.t('swal.generateCode.title'),
        text: VueI18n.t('swal.generateCode.text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: VueI18n.t('swal.generateCode.yes'),
        cancelButtonText: VueI18n.t('swal.generateCode.no'),
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (!result.value) return

        DashboardService.generateCode(this.gameUuid).then((res) => {
          this.$emit('codeGenerated', {
            gameUuid: this.gameUuid,
            code: res.data.code,
            status: res.data.status
          })

          this.$copyText(res.data.code.toString()).then(() => {
            // this.$notify('Copied to clipboard', 'success')
            this.$toast.fire({
              title: 'Copied to clipboard',
              icon: 'success'
            })
          })
        })
      })
    }
  }
}

</script>
